import type { Validation } from '../hdapi';

// TODO: Replace name property with alt when the backend is updated
export interface Image {
  url: string;
  name: string;
}

export interface KeyValueObject {
  key: string;
  value: string | number | Validation;
}

export namespace RoleConstants {
  // These are served from the backend - update there before here.
  export namespace Pricing {
    export const ViewPricing = 'read:pricing';
    export const ViewPriceLists = 'read:price-lists';
  }

  export namespace Orders {
    export const ReadOrders = 'read:orders';
    export const CreateOrders = 'create:orders';
    export const DeleteOrders = 'delete:orders';
  }

  export namespace Users {
    export const ReadUsers = 'read:users';
    export const UpdateUsers = 'update:users';
    export const CreateUsers = 'create:users';
    export const DeleteUsers = 'delete:users';
  }

  export namespace Account {
    export const UpdateAccount = 'update:account';
  }

  export namespace Products {
    export const ViewProducts = 'read:products';
  }

  export namespace Billing {
    export const ReadBilling = 'read:billing';
    export const ReadOrderHistory = 'read:order-history';
    export const ReadStatements = 'read:statements';
    export const ReadInvoices = 'read:invoices';
  }

  export namespace Downloads {
    export const ReadDownloads = 'read:downloads';
  }
}
